import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="12" height="2" viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M7.094 0h3.26c.26 0 .517.098.713.293a.997.997 0 010 1.414 1.007 1.007 0 01-.712.293H1.82c-.259 0-.516-.098-.712-.293a.997.997 0 010-1.414C1.305.098 1.562 0 1.82 0h3.26" fill="#999" /></svg>);